module.exports = __webpack_public_path__ + "assets/exactmetrics.be1ce001.svg";